import { useContext } from "react"

import { IncidentsStateContext, IncidentsDispatchContext } from "./IncidentsContext.context"


export const useIncidentsStateContext = () => {
    const context = useContext(IncidentsStateContext)
    if (context === undefined) {
        throw new Error("useIncidentsStateContext must be used within an IncidentsContextProvider")
    }
    return context
}

export const useIncidentsDispatchContext = () => {
    const context = useContext(IncidentsDispatchContext)
    if (context === undefined) {
        throw new Error("useIncidentsDispatchContext must be used within an IncidentsContextProvider")
    }
    return context
}

export const useIncidentsContext = () => {
    return [useIncidentsStateContext(), useIncidentsDispatchContext()]
}
